import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import DesktopMenu from "./deskTopMenu";
import MobileMenu from "./mobileMenu";
import { MenuContainer } from "./styles";

const MenuList = [
  ["About", "/about"],
  ["Tokenomics", "/tokenomics"],
  // ["Liquidity", "/#liquidity"],
  [
    "BUY/SELL",
    "https://app.uniswap.org/#/swap?outputCurrency=0xe36ac872eb1aefcf746feb6728b81b38fc6d75b2&chain=mainnet",
  ],
];
const checkSticky = "";
const Menu = () => {
  // const [useCheckSticky, setCheckSticky] = useState("no-sticky");
  // useEffect(() => {
  //   window.addEventListener("scroll", isSticky);
  //   return () => {
  //     window.removeEventListener("scroll", isSticky);
  //   };
  // });
  // const isSticky = (e) => {
  //   const scrollTop = window.scrollY;
  //   scrollTop >= 20 ? setCheckSticky("sticky") : setCheckSticky("No-sticky");
  // };
  return (
    <MenuContainer>
      <DesktopMenu menuList={MenuList} />
      <MobileMenu menuList={MenuList} />
    </MenuContainer>
  );
};

export default Menu;
